import { useEffect, useState } from "react";

// Mirrors the admin app's useIsMobile (frontends
// packages/admin-app/src/utils/useIsMobile.ts) so the two apps share a
// breakpoint. Below 768px the left sidebar collapses into an off-canvas
// drawer toggled from the top bar.
const MOBILE_BREAKPOINT = 768;
const MOBILE_MEDIA_QUERY = `(min-width: ${MOBILE_BREAKPOINT}px)`;

export const useIsMobile = (): boolean => {
  const [isMobile, setIsMobile] = useState(
    () => !window.matchMedia(MOBILE_MEDIA_QUERY).matches,
  );

  useEffect(() => {
    const mediaQuery = window.matchMedia(MOBILE_MEDIA_QUERY);
    const handleChange = (e: MediaQueryListEvent) => setIsMobile(!e.matches);
    mediaQuery.addEventListener("change", handleChange);
    return () => mediaQuery.removeEventListener("change", handleChange);
  }, []);

  return isMobile;
};
